import(/* webpackMode: "eager" */ "/codebuild/output/src2340012390/src/web-app/packages/webapp/app/error.tsx");
